import {
  Archive,
  Code,
  File,
  FileAudio,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
} from 'lucide-react';

import { FILE_TYPE_STYLES } from '@/constants/colors';
import { openStoredFile } from '@/helpers/storage.helper';
import { formatFileSize, getFileType, getFileTypeLabel } from '@/lib/string';
import { cn } from '@/lib/ui/utils';

interface DocumentDetailIconProps {
  url: string;
  name: string;
  size: number;
}

const getFileIcon = (fileType: string) => {
  switch (fileType) {
    case 'image':
      return FileImage;
    case 'pdf':
      return FileText;
    case 'doc':
      return FileText;
    case 'excel':
      return FileSpreadsheet;
    case 'video':
      return FileVideo;
    case 'audio':
      return FileAudio;
    case 'archive':
      return Archive;
    case 'code':
      return Code;
    default:
      return File;
  }
};

const DocumentDetailIcon = ({ url, name, size }: DocumentDetailIconProps) => {
  const fileType = getFileType(url);
  const IconComponent = getFileIcon(fileType);

  const handleDocumentClick = () => {
    openStoredFile(url);
  };

  return (
    <div
      className="flex cursor-pointer items-center gap-1"
      onClick={handleDocumentClick}
    >
      <div className="relative">
        <IconComponent className="text-border" size={50} />
        <div
          className={cn(
            'as-body-05 absolute bottom-3 rounded-sm px-1 font-bold text-white',
            FILE_TYPE_STYLES[fileType] || FILE_TYPE_STYLES.default
          )}
        >
          {getFileTypeLabel(url)}
        </div>
      </div>
      <div>
        <p className="as-title-03 font-medium">{name}</p>
        <p className="as-body-04">{formatFileSize(size)}</p>
      </div>
    </div>
  );
};

export { DocumentDetailIcon };
